
import React from 'react'
import styled from 'styled-components'
import { Trans } from '@lingui/react'
import Logo from '../util/Logo'
import SecondaryButton from '../util/SecondaryButton'
import PrimaryButton from '../util/PrimaryButton'

const ModalLexorInstaller = ({
    handleInstallClick,
    handleClosePopup,

}) => <div
            style={{
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(51, 48, 48, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
              position: 'relative'
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 10,
                background: "white",
                padding: 20,
                borderRadius: 8,
                width: 480,
                height: 230,
                textAlign: "center",
              }}
            >
              <Logo />  
              <SubTitle className="mt-4">
              <Trans id="Install Lexor as an application on your PC? You can pin it to your desktop or let it start each time you start your PC." />
              </SubTitle>
              <div className="flex justify-end mt-6">
              <PrimaryButton onClick={()=>handleInstallClick()} style={{ marginRight: 10 }}>
                <Trans id="Yes" /> 
              </PrimaryButton>
              <SecondaryButton onClick={()=>handleClosePopup()}> <Trans id="No"/> </SecondaryButton>
              </div>
            </div>
        </div>

        export default ModalLexorInstaller


const SubTitle = styled.h3(
    ({ theme }) => `
    color: ${theme.colorGrey};
    font-size: ${theme.fontSizeLarger}rem;
    font-weight: ${theme.fontWeightRegular};
`,
)